module.exports = __webpack_public_path__ + "img/index-bottom-bg.0d6185ca.png";